module.exports = __webpack_public_path__ + "static/favicon-76e6cf3e7b6e7dd83356ad3af68d7cac.ico";